const dvt=[

{
label:"Side",
controlType:"radio button",
options:["Right","Left", "Bilateral"]
},
{
label:"Present for several:",
controlType:"radio button",
options:["Days", "Weeks","Months","Years"]
}
    

]


export default dvt